export default __webpack_public_path__ + "static/media/expand-more.c20ca823.svg";